import { type ChangeEventHandler } from "react";
import { useDropzone, type Accept } from "react-dropzone";
import { Trans, useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { UploadIcon } from "@components/icons";

interface IDropzoneProps {
  multiple?: boolean;
  onChange?: ChangeEventHandler<HTMLInputElement>;
  disabled?: boolean;
  acceptedFiles?: Accept;
}

export const Dropzone: React.FC<IDropzoneProps> = ({
  multiple,
  onChange,
  disabled,
  acceptedFiles,
  ...rest
}) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple,
    accept: acceptedFiles,
    ...rest,
  });
  const { t } = useTranslation();

  return (
    <div
      {...getRootProps()}
      className={twMerge(
        "flex cursor-pointer flex-col items-center rounded-2xl border border-grey-light px-3.5 py-6 transition-colors duration-100",
        disabled && "bg-base-light-grey",
      )}
    >
      <input {...getInputProps({ onChange })} />
      <div
        className={twMerge(
          "mb-4 w-fit rounded-full bg-green-light p-3.5",
          disabled && "bg-grey-light",
        )}
      >
        <UploadIcon className="h-5 w-5" />
      </div>
      {isDragActive ? (
        <p className="text-center text-sm">{t("fileUpload.dragHere")}</p>
      ) : (
        <p className="text-center text-sm text-grey-dark">
          <Trans
            i18nKey={"fileUpload.clickOrDragFile"}
            components={{
              bolder: (
                <span
                  className={twMerge(
                    "font-semibold text-base-black",
                    disabled && "text-grey-dark",
                  )}
                ></span>
              ),
            }}
          />
        </p>
      )}
    </div>
  );
};
